import React, { ReactNode } from 'react';

import { Paper, ScrollArea, Stack } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { ExtractedItemsNavigationHeader } from 'components/ExtractedContent/ExtractedItemsNavigation/ExtractedItemsNavigationHeader';
import { SearchField, SearchFormValues } from 'components/ExtractedContent/ExtractedItemsNavigation/SearchField';

interface ExtractedItemsNavigationProps {
  title: string;
  tooltip: string;
  searchForm: UseFormReturnType<SearchFormValues>;
  children: ReactNode;
}

export function ExtractedItemsNavigation({ title, tooltip, searchForm, children }: ExtractedItemsNavigationProps) {
  return (
    <Paper h="100%" withBorder shadow="sm" radius="md">
      <Stack h="100%">
        <ExtractedItemsNavigationHeader title={title} tooltip={tooltip} />
        <SearchField searchForm={searchForm} />
        <ScrollArea type="auto" offsetScrollbars scrollbarSize={6}>
          {children}
        </ScrollArea>
      </Stack>
    </Paper>
  );
}
